import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CommonToast } from './components/shared/common-toast/common-toast';


@Component({
  selector: 'app-root',
  imports: [RouterOutlet,CommonToast],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App {
  protected readonly title = signal('Distribution-Management-System-Frontend');
}
